import styled, { css } from 'styled-components'
import { hideVisually } from 'polished'

const Main = styled.main`
  background-color: white;
`

const Hero = styled.section`
  ${({ theme }) => css`
    position: relative;
    z-index: 1;
    padding: ${theme.spacing(5)} ${theme.spacing(7)};

    ${theme.media('xs')} {
      padding: ${theme.spacing(5)} ${theme.spacing(15)};
    }

    ${theme.media('sm')} {
      padding: ${theme.spacing(10)} ${theme.spacing(10)} ${theme.spacing(7)};
    }

    .pattern {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-image: linear-gradient(180deg, #f3f3f3 0%, #f3f3f3 76.56%, #e6e6e6 81.25%, #e6e6e6 100%);
      z-index: -1;
    }
  `}
`

const HeroInner = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing(4)};
    max-width: 100rem;
    margin: 0 auto;
    text-align: center;

    ${theme.media('sm')} {
      flex-direction: row;
      text-align: left;
    }

    img {
      flex-shrink: 0;
      max-width: 20rem;

      ${theme.media('sm')} {
        max-width: 28rem;
      }

      ${theme.media('md')} {
        max-width: 42rem;
        max-height: 48rem;
      }

      & + a {
        ${theme.media('sm')} {
          ${hideVisually()}
        }
      }
    }
  `}
`

const HeroContent = styled.div`
  ${({ theme }) => css`
    position: relative;

    h1 {
      margin: 0 0 ${theme.spacing(2)};
      font-size: 4rem;

      ${theme.media('md')} {
        font-size: 4.6rem;
      }

      ${theme.media('lg')} {
        font-size: 5.2rem;
      }
    }

    p {
      margin: 0;
      font-size: 1.8rem;
      font-weight: 300;
      opacity: 0.9;

      ${theme.media('sm')} {
        margin-bottom: ${theme.spacing(5)};
      }

      ${theme.media('md')} {
        margin-bottom: ${theme.spacing(7)};
        font-size: 2.1rem;
      }

      &.home_pretitle {
        margin-bottom: ${theme.spacing(1)};
      }
    }

    a {
      ${theme.maxMedia('sm')} {
        ${hideVisually()}
      }
    }
  `}
`

const Sponsor = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2.5)} 0;
    font-size: 1.4rem;
  `}
`

const StepSection = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(5)};
    max-width: 104.2rem;
    padding: ${theme.spacing(4)};
    margin: 0 auto;
    text-align: center;

    h4 {
      margin: 0;
      text-align: center;
    }

    ${theme.maxMedia('sm')} {
      ol {
        padding-left: 0;
      }
    }

    ${theme.media('xs')} {
      padding: ${theme.spacing(5)} ${theme.spacing(8)};
    }

    ${theme.media('md')} {
      padding: ${theme.spacing(5)} ${theme.spacing(10)};
    }
  `}
`
const FooterTerms = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(5)};
    max-width: 104.2rem;
    padding: ${theme.spacing(4)};
    margin: 0 auto;
    text-align: center;

    .smallText {
      font-size: 1.3rem;
      color: ${theme.palette.grey[500]};
    }
  `}
`

const StepList = styled.ol`
  width: 100%;
`

export default {
  Main,
  Hero,
  HeroInner,
  HeroContent,
  StepSection,
  Sponsor,
  FooterTerms,
  StepList,
}
